// Vendor Libs
import React, {useEffect, useState, useContext} from 'react';
import PropTypes from 'prop-types';

// Material UI
import {Button, Container} from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import SaveIcon from '@material-ui/icons/Save';
import {makeStyles} from '@material-ui/core/styles';

// Dish Tech React
import {InputTextField} from '@dishtech-react/core';
import {useForm, useToast, useRouter} from '@dishtech-react/hooks';

import {RouteContext} from '../../contexts/route-context';

// Images
import logo from './ripple-logo.svg';

// Config
import {serviceConfig} from '../../../config/service-config';

const FORM_KEY = 'FORGOT_PASSWORD';

const useStyles = makeStyles(theme => ({
    card: {
        margin: 'auto',
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    button: {
        '&:first-of-type': {
            marginRight: '1.5em',
        },
        flex: 1,
    },
    wrap: {
        width: '100%',
        margin: '1em auto',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
    },
}));

const ForgotPasswordPage = ({redirectUrl}) => {
    const classes = useStyles();
    const routeContext = useContext(RouteContext);
    const {
        formValues: {username = ''},
        registerForm,
        resetForm,
        setFieldValue,
        submitForm,
    } = useForm(serviceConfig, FORM_KEY, 'UPDATE');
    const {createToast} = useToast();
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    useEffect(() => {
        registerForm();

        return () => resetForm();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleRouterUpdate = () => {
        routeContext.push(redirectUrl);
    };

    const handleSubmit = () => {
        const queryParams = {
            userName: username,
        };

        submitForm(queryParams).then(({error}) => {
            const msg =
                error ||
                'Request Received! If the user name entered matches user records, password reset link will be emailed.';

            setIsButtonDisabled(true);
            createToast(msg, {
                anchorOrigin: {horizontal: 'center', vertical: 'bottom'},
                onClose: () => handleRouterUpdate(),
                variant: error ? 'error' : 'success',
            });
        });
    };

    return (
        <Container maxWidth="xs">
            <div className={classes.card}>
                <img alt="ripple logo" src={logo} />

                <InputTextField
                    autoComplete="username"
                    autoFocus={true}
                    id="Username"
                    label="Username"
                    name="username"
                    type="username"
                    value={username}
                    onChange={event => setFieldValue('username', event.target.value)}
                />
                <div className={classes.wrap}>
                    <Button
                        className={classes.button}
                        color="primary"
                        disabled={username.length === 0 || isButtonDisabled}
                        startIcon={<SaveIcon />}
                        variant="contained"
                        onClick={handleSubmit}
                    >
                        Submit
                    </Button>
                    <Button
                        className={classes.button}
                        color="default"
                        disabled={isButtonDisabled}
                        startIcon={<CancelIcon />}
                        variant="contained"
                        onClick={handleRouterUpdate}
                    >
                        Cancel
                    </Button>
                </div>
            </div>
        </Container>
    );
};

const ForgotPassword = ({path, redirectUrl}) => (
    <div className="ForgotPassword">
        <RouteContext.Provider value={useRouter()}>
            <ForgotPasswordPage path={path} redirectUrl={redirectUrl} />
        </RouteContext.Provider>
    </div>
);

ForgotPasswordPage.propTypes = {
    redirectUrl: PropTypes.string,
};

ForgotPassword.propTypes = {
    path: PropTypes.string,
    redirectUrl: PropTypes.string,
};

export default ForgotPassword;
